export default {
  incomeGlOptions: state => {
    if (state.incomeGl) {
      return state.incomeGl.map(item => ({ label: item.name, value: item.code ? item.code.toString() : '' }))
    }
    return []
  },
  incomeGlByParentCategoryOptions: state => state.incomeGlByParentCategory.reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }], [{ label: 'Select', value: 'Select' }]),
  stationaryGL: state => {
    if (state.stationaryGL) {
      return state.stationaryGL.reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }], [{ label: 'Select', value: 'Select' }])
    }
    return []
  },
  levelTwoCategoryOptions: state => {
    if (state.levelTwoCategory !== null) {
      return state.levelTwoCategory.map(item => ({ label: item.description, value: item.code }))
    }
    return []
  },
  levelThreeCategoryOptions: state => {
    if (state.levelThreeCategory) {
      return state.levelThreeCategory.map(item => ({ label: item.description, value: item.code }))
    }
    return []
  },
  ifrsCategoryList: state => {
    if (state.ifrsCategory) {
      return state.ifrsCategory.map(item => ({ label: item.description, value: item.id }))
    }
    return []
  },
  accountOfficerOptions: state => {
    if (state.accountOfficerList !== null) {
      return state.accountOfficerList.map(item => ({ label: item.name, value: item.code }))
    }
    return []
  },
  getTillAccountBalance: state => state.tillAccountBalance,
}
